import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { SharedCommonUtility } from '../../../shared/utils/common.utility';

export interface TenantWorkspaceStatus {
  workspacesLoaded: number;
  digitalPropertiesLoaded: number;
  error?: string;
}

@Injectable({ providedIn: 'root' })
export class TenantWorkspaceService {
  private readonly status: BehaviorSubject<TenantWorkspaceStatus>;
  private readonly statusChange$: Observable<TenantWorkspaceStatus>;

  constructor() {
    this.status = new BehaviorSubject<TenantWorkspaceStatus>({
      workspacesLoaded: 0,
      digitalPropertiesLoaded: 0,
    });
    this.statusChange$ = this.status.pipe(filter(SharedCommonUtility.notNullish), distinctUntilChanged());
  }

  public get workspacesStatusChange$(): Observable<TenantWorkspaceStatus> {
    return this.statusChange$;
  }

  public set workspacesStatus(status: TenantWorkspaceStatus) {
    this.status.next(status);
  }

  public resetWorkspacesStatus(): void {
    this.status.next({
      workspacesLoaded: 0,
      digitalPropertiesLoaded: 0,
      error: undefined,
    });
  }
}
